export default __webpack_public_path__ + "static/media/ic-attempted (3).f36672c1.svg";